import Swiper, { Thumbs, Lazy, Navigation } from "swiper";

class Gallery {
  wrapper = null;

  constructor(el) {
    this.wrapper = $(el);

    if (this.wrapper.length) {
      this.init();
    }
  }

  init() {
    const thumbsSliderEl = this.wrapper.find(".thumbs-slider");
    const gallerySliderEl = this.wrapper.find(".large-slider");

    const thumbsSwiper = new Swiper(thumbsSliderEl[0], {
      slidesPerView: 2,
      freeMode: true,
      watchSlidesProgress: true,
      spaceBetween: 8,
      breakpoints: {
        400: {
          slidesPerView: 3,
        },
        600: {
          slidesPerView: 4,
        },
        900: {
          slidesPerView: "auto",
          spaceBetween: 0,
        },
      },
    });

    new Swiper(gallerySliderEl[0], {
      modules: [Lazy, Navigation, Thumbs],
      slidesPerView: 1,
      spaceBetween: 16,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        prevEl: this.wrapper.find(".slider-nav__btn-prev")[0],
        nextEl: this.wrapper.find(".slider-nav__btn-next")[0],
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  }
}

export default Gallery;
